import { useContext, useEffect } from 'react';

import { OnboardingContext } from '../../context/OnboardingContext';
import { SubscriptionCheckout } from '../../ui';

const SubscriptionContainer = () => {
  const { setProgressPercentage } = useContext(OnboardingContext);

  useEffect(() => {
    setProgressPercentage(95);
  }, []);

  return <SubscriptionCheckout returnUrl={`${window.location.origin}/onboarding/subscribed`} />;
};

export default SubscriptionContainer;
